<ng-container *ngIf="route">
  <span *ngIf="deliveryMode===deliveryModeKind.Deliver">Bezorgen voor
    {{mainService.getHumanDateString(route.EndDateTime, true)}} (Route {{route.StartDateTime | date:'HH:mm'}}:
    {{route.Name}}
    <span *ngIf="withDescription"> {{route.Description}}</span>)
  </span>
  <span *ngIf="deliveryMode===deliveryModeKind.Pickup">Afhalen {{mainService.getHumanDateString(route.StartDateTime,
    true, ' om ')}}</span>
</ng-container>